import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { useState } from "react";

/**
 * Table header for filtering only by calendar
 * @param {object} props
 * @param {Function} props.setLazyFilters
 */
export default function SimpleCalendarTableHeader({ setLazyFilters }) {
  const [dateFilter, setDateFilter] = useState(null);

  return (
    <div className="full-w-header">
      <div className="mt-3 mb-2">
        <FloatLabel>
          <Calendar
            locale="es"
            inputId="created_date"
            value={dateFilter}
            onChange={(e) => {
              if (["click", "keypress"].includes(e.originalEvent.type)) {
                setDateFilter(e.value);
                const dateFormat = e.value?.toISOString().split("T")[0];
                setLazyFilters((prev) => ({
                  ...prev,
                  created_at__date: dateFormat,
                }));
              }
              if (e.value === dateFilter) return;
              if (!e.value) setDateFilter(null);
            }}
            dateFormat="mm/dd/yy"
            placeholder="dia/mes/año"
            mask="99/99/9999"
            showButtonBar
          />
          <label htmlFor="created_date">Buscar por fecha</label>
        </FloatLabel>
      </div>
    </div>
  );
}
